'use client';
import styled, { css } from 'styled-components';

export const StyledPhotoLabelsOverlayContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const StyledPhotoLabelsContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const PhotoLabel = styled.div`
  position: absolute;
  top: ${props => props.$topMobile ?? 0}%;
  left: ${props => props.$leftMobile ?? 0}%;
  width: 170px;
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing(3, 2, 3, 3)};
  border-radius: 17.5px;
  background: rgba(255, 255, 255, 0.75);
  opacity: ${props => (props.$show ? 1 : 0)};
  transform: ${props =>
    props.$show ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.96)'};
  transition: ${props =>
    props.$show
      ? 'opacity 300ms ease-out, transform 520ms cubic-bezier(0.34, 1.56, 0.64, 1)'
      : 'opacity 200ms ease-in, transform 200ms ease-in'};
  will-change: transform, opacity;

  ${props =>
    props.$cornerDotAlignment &&
    `
    &::before {
      content: '';
      position: absolute;
      top: 6px;
      ${
        props.$cornerDotAlignment === 'right'
          ? 'right: 6px; transform: translate(51%, -50%);'
          : 'left: 6px; transform: translate(-50%, -50%);'
      }
      width: 8.5px;
      height: 8.5px;
      border-radius: 50%;
      background: white;
    }
  `}

  @media ${({ theme }) => theme.tablet} {
    top: ${props => props.$top ?? 0}%;
    left: ${props => props.$left ?? 0}%;
    padding: ${props => props.theme.spacing(4, 6)};
    border-radius: 26px;
    width: 230px;

    ${props =>
      props.$cornerDotAlignment &&
      `
      &::before {
        top: 8px;
        ${
          props.$cornerDotAlignment === 'right'
            ? 'right: 8px; transform: translate(51%, -50%);'
            : 'left: 8px; transform: translate(-50%, -50%);'
        }
        width: 12px;
        height: 12px;
      }
    `}
  }
`;

export const Label = styled.p`
  ${props =>
    props.$typography
      ? props.theme.typography[props.$typography]
      : css`
          leading-trim: both;
          text-edge: cap;
          font-family: 'ABC Social Condensed';
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: 110%;
        `};
  color: ${props =>
    props.theme.colors.get(props.$fontColor, props.theme.colors.text.primary)};

  @media ${({ theme }) => theme.tablet} {
    ${props =>
      props.$typography
        ? props.theme.typography[props.$typography]
        : css`
            leading-trim: both;
            text-edge: cap;
            font-family: 'ABC Social Condensed';
            font-size: 20px;
            font-style: normal;
            font-weight: 500;
            line-height: 110%;
          `};
  }
`;

export const Description = styled.p`
  ${props =>
    props.$typography
      ? props.theme.typography[props.$typography]
      : css`
          font-family: 'ABC Social';
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 130%;
        `};
  color: ${props =>
    props.theme.colors.get(props.$fontColor, props.theme.colors.text.primary)};

  @media ${({ theme }) => theme.tablet} {
    ${props =>
      props.$typography
        ? props.theme.typography[props.$typography]
        : css`
            font-family: 'ABC Social';
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 130%;
          `};
  }
`;
